//libraries and utilities
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';



/*******************************************************************************
 *
 *   1. connectAndMap
 *   2. checkUserAgent
 *   3. formatting helpers
 *   4. IE polyfills
 *   5. checkFetching
 * 
 *
 */

/*******************************************************************************
 *  1. connectAndMap
 *
 *
 * returns specific parts of your store as well as actionCreators bound with dispatch
 *
 * dataCodes: an array of dataCode strings that references which part of the store to connect the component to - default is null
 * actionCreators: an object containing functions that will be connected to the component, and have dispatch bound to them - default is null
*/
var connectAndMap = ( dataCodes, actionCreators ) => connect(
    dataCodes
    ? ( state ) =>
         {
            const newProps = {};
            for ( const dataCode in dataCodes ) {

                const codes = dataCodes[ dataCode ].split( '.' );

                let data = state[ codes[ 0 ] ];

                for( let i = 1; i < codes.length; i ++ ) {
                    data = data[ codes[ i ] ];
                }

                newProps[ codes[ codes.length - 1 ] ] = data;

            }
            return newProps;
        }
    : null,
    actionCreators
    ? ( dispatch ) => bindActionCreators( actionCreators, dispatch )
    : null,
    null,
    { pure: true }
);

/*******************************************************************************
 *  2. check user agent
 *
 *
 * USE AS A LAST RESORT
 * sets some values based on navigator.userAgent, to make a modification based on OS or browser
 */
const checkUserAgent = () => {
    const userAgent = navigator.userAgent;
    if( userAgent.indexOf( 'Windows NT 6.1' ) > 0 ) {
        UA_WINDOWS = true;
    }
    if( userAgent.indexOf( 'Macintosh' ) > 0 ) {
        UA_MAC = true;
    }
    if( userAgent.indexOf( 'Internet Explorer' ) > 0 ) {
        UA_IE = true;
    }
    if( userAgent.indexOf( 'Firefox' ) > 0 ) {
        UA_FIREFOX = true;
    }
    if( userAgent.indexOf( 'Safari' ) > 0 && navigator.userAgent.indexOf( 'Chrome' ) < 1 ) {
        UA_SAFARI = true;
    }
     if( userAgent.indexOf( 'Chrome' ) > 0 ) {
        UA_CHROME = true;
    }
};

/*******************************************************************************
 *  3. formatting helpers
 *
 * simple helpers to format strings
 */

var formatNameString = ( string ) => {
    return string.replace( /\w\S*/g, function( txt ) {
        return txt.charAt( 0 ).toUpperCase() + txt.substr( 1 ).toLowerCase();
    } );
};

var formatMetricString = ( string ) => {
    string = string.split( '-' );
    if( string[ 1 ] ) {
        return string[ 0 ] + '-' + string[ 1 ].replace( /\w\S*/g, function( txt ) {
            return txt.charAt( 0 ).toUpperCase() + txt.substr( 1 ).toLowerCase();
        } );
    }else{
        return string;
    }
};

var formatCamelCase = ( string ) => {
    string = string.replace( /([A-Z])/g, ' $1' );
    string = string.charAt( 0 ).toUpperCase() + string.slice( 1 );
    return string;
};

/*******************************************************************************
 *  4. IE polyfills
 *
 *
 * some fancy javascript doesn't work in IE11, we need polyfills to get them to work.
 * some polyfills are here, others are imported and compiled with webpack
 */
var objectAssignBackup = () => {
    if ( typeof Object.assign != 'function' ) {
      Object.assign = function( target ) {
        'use strict';
        if ( target == null ) {
          throw new TypeError( 'Cannot convert undefined or null to object' );
        }

        target = Object( target );
        for ( var index = 1; index < arguments.length; index++ ) {
          var source = arguments[index];
          if ( source != null ) {
            for ( var key in source ) {
              if ( Object.prototype.hasOwnProperty.call( source, key ) ) {
                target[ key ] = source[ key ];
              }
            }
          }
        }
        return target;
      };
    }
};

/*******************************************************************************
 *  5. checkFetching
 *
 *  User by shared/loader component to determine fetching status based on
 */
var checkFetching = ( fetching, fetchCodes ) => {
    let loader = false;

    if( fetching && fetchCodes ) {
        for( const i in fetching ) {
            for( const k in fetchCodes ) {
                if( i.indexOf( fetchCodes[ k ] ) > -1 && fetching[ i ] === true ) { loader = true; }
            }
        }
    }else{
        loader = true;
    }

    return loader;
};

export{
    connectAndMap as connectAndMap,
    checkUserAgent as checkUserAgent,
    formatNameString as formatNameString,
    formatMetricString as formatMetricString,
    formatCamelCase as formatCamelCase,
    objectAssignBackup as objectAssignBackup,
    checkFetching as checkFetching
};



// WEBPACK FOOTER //
// ./src/utils/utils.js